import { axios } from '@/services/axios';

const getTrunkType = (trunkTypeId) => {
    return axios.get(`/trunktype/${trunkTypeId}`);
};

export default getTrunkType;
